<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("dictamen module settings") }}
      </h1>
    </div>

    <div class="box">
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('analyst signer')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/signer/catalog"
              name_field="name"
              value_field="signer_id"
              @selected="analyst_signer_changed"
              ref="analyst_signer_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('credit head signer')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/signer/catalog"
              name_field="name"
              value_field="signer_id"
              @selected="operation_manager_signer_changed"
              ref="operation_manager_signer_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("rci threshold") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.rci_threshold"
                placeholder="0.6"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default nationality") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.default_nationality"
                placeholder="GUATEMALTECO(A)"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default purpose") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.default_purpose"
                placeholder="Capital de trabajo"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("sirc file name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.sirc_file_name"
                placeholder="SIRC.pdf"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("months term for credit card") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.months_term_for_credit_card"
                placeholder="60"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="title is-5">{{ $t("logo") }}</div>
      <div class="columns">
        <div class="column is-5">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
        <div class="column">
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop logo image here')"
            endpoint_url="/blacklist-report/logo"
            :allow_multiple="false"
            @error="error_uploading"
            @success="success_uploading"
          />
          <figure class="image is-128x128 mt-5" v-if="meta.logo">
            <img
              :src="`${api_host}/drive/static/${meta.logo.final_name}`"
              :alt="meta.logo.original_name"
            />
          </figure>
        </div>
      </div>
    </div>

    <div class="box">
      <h1 class="title is-5 mt-5">{{ $t("sirc settings") }}</h1>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{
              $t("api url for getting sirc users")
            }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.sirc_users_api_url"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{
              $t("api url for getting sirc report")
            }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.sirc_report_api_url"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column" v-if="meta.sirc_users_api_url">
          <generic-dropdown
            :title="$t('sirc profile')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            :url="meta.sirc_users_api_url"
            name_field="name"
            value_field="profile_id"
            @selected="sirc_profile_changed"
            ref="sirc_profile_dropdown"
          />
          <!-- <div class="field">
          <label class="label">{{ $t("sirc profile") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="text" v-model="meta.sirc_profile" />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div> -->
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("sirc api username") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.sirc_api_username"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("sirc api password") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="password"
                v-model="meta.sirc_api_password"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-key"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="title is-4">{{ $t("dictamen database configuration") }}</div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("host") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.dictamen_db_host"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("port") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.dictamen_db_port"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-plug"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("database") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.dictamen_db_database"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-database"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("username") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.dictamen_db_username"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("password") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="password"
                v-model="meta.dictamen_db_password"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="title is-4">
        {{ $t("wealth status database configuration") }}
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("host") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.wealth_status_db_host"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("port") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.wealth_status_db_port"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-plug"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("database") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.wealth_status_db_database"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-database"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("username") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.wealth_status_db_username"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("password") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="password"
                v-model="meta.wealth_status_db_password"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="title is-4">
        {{ $t("renap database configuration") }}
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("host") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input class="input" type="text" v-model="meta.renap_db_host" />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("port") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input class="input" type="text" v-model="meta.renap_db_port" />
              <span class="icon is-small is-left">
                <i class="fa fa-plug"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("database") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.renap_db_database"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-database"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("username") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                v-model="meta.renap_db_username"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("password") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="password"
                v-model="meta.renap_db_password"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">&nbsp;</label>
            <div class="control">
              <div
                class="button is-rounded is-primary"
                @click="test_renap_connection"
              >
                <span class="icon is-small">
                  <i class="fa fa-bolt"></i>
                </span>
                <span>{{ $t("test") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('sib data extraction script')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/script/catalog"
              name_field="name"
              value_field="directory"
              @selected="sib_extraction_script_changed"
              ref="script_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('report generation script')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/script/catalog"
              name_field="name"
              value_field="directory"
              @selected="sib_report_script_changed"
              ref="report_script_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("shared directory path") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shared_directory_path"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{
              $t("success endpoint url (extraction)")
            }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.success_endpoint_url_extraction"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{
              $t("error endpoint url (extraction)")
            }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.error_endpoint_url_extraction"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <label class="label">{{
              $t("success endpoint url (report)")
            }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.success_endpoint_url_report"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("error endpoint url (report)") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.error_endpoint_url_report"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  api_host,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "DictamenSettings",
  components: { GenericDropdown, GenericUploader },
  data() {
    return {
      meta: {},
      api_host,
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    sib_extraction_script_changed(script) {
      let v = this;
      if (script) {
        v.meta.sib_extraction_script = script;
      }
    },
    analyst_signer_changed(signer) {
      let v = this;
      if (signer) {
        v.meta.analyst_signer_id = signer.signer_id;
      }
    },
    operation_manager_signer_changed(signer) {
      let v = this;
      if (signer) {
        v.meta.operation_manager_signer_id = signer.signer_id;
      }
    },
    sib_report_script_changed(script) {
      let v = this;
      if (script) {
        v.meta.sib_report_script = script;
      }
    },
    drive_changed(drive) {
      let v = this;
      if (drive) {
        v.meta.drive_id = drive.drive_id;
      }
    },
    error_uploading(error) {
      console.error(error);
      error_message(error);
    },
    success_uploading(response) {
      let v = this;
      v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };

      v.meta.logo = data;
    },
    test_renap_connection() {
      let v = this;
      v.$root.loader(true);
      post("/dictamen/test-renap-connection", {
        server: v.meta.renap_db_host,
        port: v.meta.renap_db_port,
        database: v.meta.renap_db_database,
        username: v.meta.renap_db_username,
        password: v.meta.renap_db_password,
      })
        .then((response) => {
          success_message(v.$t("renap database connection successful"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    sirc_profile_changed(profile) {
      let v = this;
      if (profile) {
        v.meta.sirc_profile = profile.profile_id;
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) v.meta = conf;

        if (
          v.meta.sib_extraction_script &&
          v.meta.sib_extraction_script.directory
        )
          v.$refs.script_dropdown.set_value(
            v.meta.sib_extraction_script.directory
          );

        if (v.meta.analyst_signer_id)
          v.$refs.analyst_signer_dropdown.set_value(v.meta.analyst_signer_id);

        if (v.meta.operation_manager_signer_id)
          v.$refs.operation_manager_signer_dropdown.set_value(
            v.meta.operation_manager_signer_id
          );

        if (v.meta.sib_report_script && v.meta.sib_report_script.directory)
          v.$refs.report_script_dropdown.set_value(
            v.meta.sib_report_script.directory
          );

        if (v.meta.drive_id) v.$refs.drive_dropdown.set_value(v.meta.drive_id);

        setTimeout(() => {
          if (v.meta.sirc_profile && v.$refs.sirc_profile_dropdown)
            v.$refs.sirc_profile_dropdown.set_value(v.meta.sirc_profile);
        }, 1000); // Wait for dropdowns to render
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
